import CommunicationStatusScreen from './CommunicationStatusScreen.js';

export default CommunicationStatusScreen;
